import React from "react";

export function SizeChartTable({ chart }) {
  if (!chart || !Array.isArray(chart.columns) || !chart.columns.length) return null;
  return (
    <div data-testid="size-chart-table" style={{ overflowX: "auto", border: "1px solid var(--border-default)", borderRadius: "var(--radius-lg)" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", font: "var(--fw-regular) 13px/1.4 var(--font-sans)" }}>
        <thead>
          <tr style={{ background: "var(--surface-muted)", textAlign: "left" }}>
            {chart.columns.map((c, i) => (
              <th key={i} style={{ padding: "10px 12px", font: "var(--fw-semibold) 11px/1.3 var(--font-sans)", letterSpacing: "0.04em", textTransform: "uppercase", color: "var(--text-tertiary)", whiteSpace: "nowrap" }}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {chart.rows.map((r, ri) => (
            <tr key={ri} style={{ borderTop: "1px solid var(--border-default)" }}>
              {chart.columns.map((_, ci) => (
                <td key={ci} style={{ padding: "9px 12px", fontFamily: ci === 0 ? "var(--font-sans)" : "var(--font-mono)", color: "var(--text-primary)", whiteSpace: "nowrap", fontWeight: ci === 0 ? 600 : 400 }}>{r[ci] ?? ""}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
